import { memo, Ref } from "react";

import TableBodyRow from "ds/components/Table/Row";
import { TableColumnMeta } from "ds/components/Table/types";
import { isStickyLeft, isStickyRight } from "ds/components/TableSimple/helpers";
import { VcsProvider } from "types/generated";

import { ModulePullRequestsTableRow } from "../../gql";
import { MODULE_PULL_REQUESTS_PULL_REQUEST_CELLS } from "../Cells/PullRequest";

type ModulePullRequestsTableRowPullRequestProps = {
  pullRequest: ModulePullRequestsTableRow;
  moduleId: string;
  moduleProvider: VcsProvider;
  columns: TableColumnMeta[];
  isFirstColumnPinned: boolean;
  keyboardProps: Record<string, unknown>;
  measureRef: Ref<HTMLDivElement>;
  dataIndex: number;
  isGroupOpen?: boolean;
  isExpanded?: boolean;
  className?: string;
};

const ModulePullRequestsTableRowPullRequest = ({
  pullRequest,
  moduleId,
  moduleProvider,
  columns,
  isFirstColumnPinned,
  keyboardProps,
  measureRef,
  dataIndex,
  isGroupOpen,
  className,
  isExpanded,
}: ModulePullRequestsTableRowPullRequestProps) => (
  <TableBodyRow
    {...keyboardProps}
    ref={measureRef}
    dataIndex={dataIndex}
    virtualized
    className={className}
    isGroupOpen={isGroupOpen}
    aria-level={1}
    aria-expanded={isExpanded}
  >
    {columns.map((column, i) => {
      const Cell = MODULE_PULL_REQUESTS_PULL_REQUEST_CELLS[column.id];
      const cellId = `${pullRequest.id}-${column.id}`;

      return (
        <Cell
          key={cellId}
          id={cellId}
          item={pullRequest}
          isFirst={i === 0}
          stickyLeft={isStickyLeft(i, isFirstColumnPinned)}
          stickyRight={isStickyRight(i, columns.length)}
          moduleId={moduleId}
          moduleProvider={moduleProvider}
        />
      );
    })}
  </TableBodyRow>
);

export default memo(ModulePullRequestsTableRowPullRequest);
